import { Route, Routes } from "react-router-dom";
import { Container, Spinner } from "react-bootstrap";
import { Suspense, lazy } from "react";
import FinanceMaster from "../Maintenance/FinanceMaster";
import Loader from "../common/loader";
import VendorMaster from "../Maintenance/VendorMaster";
import ReportLogMaster from "../Report/ReportLogMaster";
import BranchUserValidationLog from "../Report/BranchUserValidationLog";
import ProductQtyMaster from "../Maintenance/ProductQtyMaster";
import SerialNumberDispatchLog from "../Report/SerialNumberDispatchLog";
import UnblockSerialNoMaster from "../Maintenance/UnblockSerialNoMaster";
import ProtectedRoute from "../common/ProtectedRoute";
import Unauthorized from "../common/Unauthorized";

const MarkSpecialCase = lazy(() => import("../Maintenance/MarkSpecialCase"));
const Dashboard = lazy(() => import("../dashboard/Dashboard"));
const UserMaster = lazy(()=>import("../Admin/UserMaster"))
const RoleMaster = lazy(()=>import("../Admin/RoleMaster"))
const CabinetMaster = lazy(()=>import("../Maintenance/CabinetNoMaster"))

export default function Main(props) {
  return (
    <Container bsPrefix="main">
      <Routes>
        <Route exact path="/" element={<Suspense fallback={<Loader/>}><Dashboard /></Suspense>}></Route>
        <Route exact path="/unauthorized" element={<Unauthorized />}></Route>
        
        <Route exact path="/user" element={
          <ProtectedRoute requiredSession="Maintain User">
            <Suspense fallback={<Loader/>}><UserMaster /></Suspense>
          </ProtectedRoute>
        }></Route>
        
        <Route exact path="/role" element={
          <ProtectedRoute requiredSession="Role and Authorization">
            <Suspense fallback={<Loader/>}><RoleMaster /></Suspense>
          </ProtectedRoute>
        }></Route>
        
        <Route exact path="/finance" element={
          <ProtectedRoute requiredSession="Tagging">
            <Suspense fallback={<Loader/>}><FinanceMaster /></Suspense>
          </ProtectedRoute>
        }></Route>
        
        <Route exact path="/vendors" element={
          <ProtectedRoute requiredSession="Maintain Vendor Details">
            <Suspense fallback={<Loader/>}><VendorMaster /></Suspense>
          </ProtectedRoute>
        }></Route>
        
        
        <Route exact path="/specialcases" element={
          <ProtectedRoute requiredSession="Serial Number Dispatch Details">
            <Suspense fallback={<Loader/>}><MarkSpecialCase /></Suspense>
          </ProtectedRoute>
        }></Route>
        
        <Route exact path="/report" element={
          <ProtectedRoute requiredSession="Validation Log Report">
            <Suspense fallback={<Loader/>}><ReportLogMaster /></Suspense>
          </ProtectedRoute>
        }></Route>
        
        <Route exact path="/branch-validation-log" element={
          <ProtectedRoute requiredSession="Branch Validation Log Report">
            <Suspense fallback={<Loader/>}><BranchUserValidationLog /></Suspense>
          </ProtectedRoute>
        }></Route>
        
        <Route exact path="/serialnoDispatch" element={
          <ProtectedRoute requiredSession="Serial Number Dispatch">
            <Suspense fallback={<Loader/>}><SerialNumberDispatchLog /></Suspense>
          </ProtectedRoute>
        }></Route>
        
        <Route exact path="/quantity" element={
          <ProtectedRoute requiredSession="Maintain Product Quantity">
            <Suspense fallback={<Loader/>}><ProductQtyMaster /></Suspense>
          </ProtectedRoute>
        }></Route>
        
        <Route exact path="/unblockSerialNo" element={
          <ProtectedRoute requiredSession="Unblock Serial Number">
            <Suspense fallback={<Loader/>}><UnblockSerialNoMaster /></Suspense>
          </ProtectedRoute>
        }></Route>
      </Routes>
    </Container>
  );
}
